(() => {
  const modules = new Map();
  const mount = (root) => {
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    root.querySelectorAll('[data-studio-module]').forEach((element) => {
      const setup = modules.get(element.dataset.studioModule);
      if (setup) setup(element);
    });
  };
  window.VastAuraNailStudio = Object.freeze({
    version: '0.1',
    register(name, setup) { if (typeof setup === 'function') modules.set(name, setup); },
    mount
  });
  document.querySelectorAll('[data-nail-studio]').forEach(mount);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-nail-studio]').forEach(mount));
})();
